import { Box, Button, Fab, IconButton, MenuItem, TextField, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { useMain } from '../../../contexts/MainContext';
import constantes from '../../../config/constantes';
import { Forward, RecordVoiceOver } from '@mui/icons-material';
import dayjs from 'dayjs';
import { updateAtendimento } from '../../../services/atendimento';
import { getTiposResumos } from '../../../services/resumo';
import { toast } from 'react-toastify';
import CriadorTipoAtendimento from '../CriadorTipoAtendimento/CriadorTipoAtendimento';
import SeletorCriacaoTipoAtendimento from '../CriadorTipoAtendimento/SeletorCriacaoTipoAtendimento';

function SelecionaResumo() {
    const { usuario, setPopupGravaMarcaVocal, popUpGravaMarcaVocal } = useMain();
    const { atendimento, setAtendimento, refreshAtendimento } = useOutletContext();
    const theme = useTheme();
    const params = useParams();
    const navigate = useNavigate();
    const { tiposResumos, setTiposResumos, setTipoResumoSelecionado } = useOutletContext();
    const timeoutSalvaAtualizacaoAtendimento = useRef(null);
    const timeoutSalvaAtualizacaoAtendimentoData = useRef(null);
    const [datanascimentoPaciente, setDataNascimentoPaciente] = useState('');
    const [seletorAberto, setSeletorAberto] = useState(false);
    const [criadorAberto, setCriadorAberto] = useState(false);
    const [modeloBase, setModeloBase] = useState(null);

    useEffect(() => {
        console.log('Atendimento atualizado:', atendimento.sexoPaciente);
        setDataNascimentoPaciente(dayjs(atendimento.nascimentoPaciente).format('YYYY-MM-DD'));
    }, [atendimento]);

    const marcaVocalDeveSerGravada = useMemo(() => {
        return marcaVocalDeveSerExibida(usuario);
    }, [usuario, popUpGravaMarcaVocal]);

    useEffect(() => {
        if (usuario) {
            if (marcaVocalDeveSerExibida(usuario)) {
                setPopupGravaMarcaVocal(true);
            }
        }
    }, [setPopupGravaMarcaVocal, usuario]);

    function selecionarTipoResumo(tipoResumo) {
        setTipoResumoSelecionado(tipoResumo);
        navigate(`/main/${params.id}/${tipoResumo.value}/gravacao`);
    }

    function marcaVocalDeveSerExibida(usuario) {
        if (!usuario) return false;
        const marcaVocal = localStorage.getItem(`${constantes.audioMarcaVocal}${usuario.id}`);
        const dataMarcaVocal = localStorage.getItem(`${constantes.audioMarcaVocal}${usuario.id}-dataCriacao`);
        return !marcaVocal || new Date(dataMarcaVocal) < new Date();
    }

    const atualizaAtendimento = async (atendimento) => {
        try {
            await updateAtendimento(
                atendimento.id,
                atendimento.nome,
                atendimento.descricao,
                atendimento.nomePaciente,
                atendimento.nascimentoPaciente,
                atendimento.sexoPaciente,
            );
            await refreshAtendimento(atendimento.id);
        } catch (error) {
            console.error(error);
            toast.error('Erro ao atualizar informações do atendimento');
        }
    };

    async function handlePromptCriado(data) {
        toast.success(`Tipo de atendimento "${data.nome}" criado com sucesso!`);
        try {
            const atualizados = await getTiposResumos();
            setTiposResumos(atualizados);
        } catch (e) {
            console.error('Erro ao recarregar tipos de resumo', e);
        }
    }

    // Recebe o modelo base escolhido no seletor (null = criar do zero) e abre o chat.
    function handleSeletorConfirmar(modelo) {
        setModeloBase(modelo || null);
        setSeletorAberto(false);
        setCriadorAberto(true);
    }

    return (
        <>
            <Box display={'flex'} gap={2} pb={2} sx={{ '@media (max-width: 600px)': { flexDirection: 'column' } }}>
                {atendimento && (
                    <>
                        <TextField
                            size="small"
                            variant="outlined"
                            label="Nome do paciente"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            placeholder="Nome do paciente"
                            value={atendimento.nomePaciente || ''}
                            onChange={(e) => {
                                setAtendimento({ ...atendimento, nomePaciente: e.target.value });
                                if (timeoutSalvaAtualizacaoAtendimento.current) {
                                    clearTimeout(timeoutSalvaAtualizacaoAtendimento.current);
                                }
                                timeoutSalvaAtualizacaoAtendimento.current = setTimeout(() => {
                                    atualizaAtendimento({ ...atendimento, nomePaciente: e.target.value });
                                }, 1300);
                            }}
                        />
                        <TextField
                            size="small"
                            variant="outlined"
                            label="Idade"
                            fullWidth
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={datanascimentoPaciente}
                            onChange={(e) => {
                                setDataNascimentoPaciente(e.target.value);
                                if (timeoutSalvaAtualizacaoAtendimentoData.current) {
                                    clearTimeout(timeoutSalvaAtualizacaoAtendimentoData.current);
                                }
                                timeoutSalvaAtualizacaoAtendimentoData.current = setTimeout(() => {
                                    setAtendimento({
                                        ...atendimento,
                                        nascimentoPaciente: new Date(e.target.value).toISOString(),
                                    });
                                    atualizaAtendimento({
                                        ...atendimento,
                                        nascimentoPaciente: new Date(e.target.value).toISOString(),
                                    });
                                }, 1300);
                            }}
                        />
                        <TextField
                            size="small"
                            variant="outlined"
                            label="Sexo"
                            fullWidth
                            select
                            value={atendimento.sexoPaciente || ''}
                            onChange={(e) => {
                                setAtendimento({ ...atendimento, sexoPaciente: e.target.value });
                                atualizaAtendimento({ ...atendimento, sexoPaciente: e.target.value });
                            }}
                        >
                            <MenuItem value="masculino">Masculino</MenuItem>
                            <MenuItem value="feminino">Feminino</MenuItem>
                            <MenuItem value="outro">Outro</MenuItem>
                        </TextField>
                    </>
                )}
            </Box>
            <Box flex={1} sx={{ overflowY: 'auto' }}>
                <Typography variant="h5" fontWeight={600} textAlign={'center'} color={theme.palette.primary.dark}>
                    Selecione um tipo de resumo para continuar.
                </Typography>
                <Typography variant="body1" textAlign={'center'} color={theme.palette.text.primary} marginBottom={'10px'}>
                    Seleione o tipo de resumo que indicara a nossa inteligencia artificial qual tipo de consulta que esta sendo
                    gravado para que possamos gerar um resumo mais preciso.
                </Typography>
                {tiposResumos
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((tipoResumo) => (
                        <MenuItem
                            key={tipoResumo.id}
                            value={tipoResumo}
                            onClick={() => selecionarTipoResumo(tipoResumo)}
                            dense={true}
                        >
                            <Box display="flex" flexDirection={'column'} width={'100%'} overflow={'hidden'}>
                                <Typography variant="body1" fontWeight={600} color={theme.palette.primary.dark}>
                                    {tipoResumo.name}
                                </Typography>
                                <Typography variant="caption" color={theme.palette.text.disabled} sx={{ textWrap: 'initial' }}>
                                    {tipoResumo.description}
                                </Typography>
                            </Box>
                            <Box>
                                <IconButton aria-label="selecioar" color="primary">
                                    <Forward />
                                </IconButton>
                            </Box>
                        </MenuItem>
                    ))}

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mt: 2,
                        pb: 2,
                    }}
                >
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => setSeletorAberto(true)}
                        sx={{ borderRadius: 2 }}
                    >
                        Criar novo tipo de atendimento
                    </Button>
                </Box>
            </Box>

            {marcaVocalDeveSerGravada && !popUpGravaMarcaVocal && (
                <Fab
                    color="primary"
                    variant="extended"
                    sx={{ position: 'absolute', bottom: 40, right: 50 }}
                    onClick={() => setPopupGravaMarcaVocal(true)}
                >
                    <RecordVoiceOver sx={{ mr: 1 }} />
                    Gravar Marca Vocal
                </Fab>
            )}

            <SeletorCriacaoTipoAtendimento
                open={seletorAberto}
                onClose={() => setSeletorAberto(false)}
                tiposResumos={tiposResumos}
                onConfirmar={handleSeletorConfirmar}
            />

            <CriadorTipoAtendimento
                open={criadorAberto}
                onClose={() => setCriadorAberto(false)}
                onPromptCriado={handlePromptCriado}
                modeloBase={modeloBase}
            />
        </>
    );
}

export default SelecionaResumo;
